import { render, staticRenderFns } from "./ChapterExam.vue?vue&type=template&id=06e08a72&"
import script from "./ChapterExam.vue?vue&type=script&lang=js&"
export * from "./ChapterExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports